import { Component, OnInit } from '@angular/core';
import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';
import {AuthService} from '../../services/auth.service';
import {FuseSplashScreenService} from '../../../@fuse/services/splash-screen.service';

@Component({
    selector   : 'login',
    templateUrl: './login.component.html',
    styleUrls  : ['./login.component.scss'],
    animations : fuseAnimations
})
export class LoginComponent implements OnInit
{
    /**
     * Constructor
     *
     * @param {FormBuilder} _formBuilder
     * @param _authservice
     * @param _fuseSplashScreenService
     */
    constructor(
        private _authservice: AuthService,
        private _fuseSplashScreenService: FuseSplashScreenService,
        public auth: AuthService
    )
    {
		// auth service
        this.auth.handleAuthenticationWithHash();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
    }

    public login(): void{
		console.log("Login starts")
        this._authservice.login();
    }
}
